module.exports = __webpack_public_path__ + "static/media/engineirpd6.10847b8c.svg";